import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as UserService from '_services/user-service';

const initialState = {
    feedback: null,
    status: 'idle',
    statusObj: {},
    error: null,
};

// post a new feedback 
export const postFeedback = createAsyncThunk('feedback/postFeedback', async (feedback) => {
    return UserService.postFeedback(feedback);
});

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [postFeedback.pending]: (state, action) => {
            return {
                ...state,
                status: 'loading',
                statusObj: { ...state.statusObj, postFeedback: 'loading' }
            }
        },
        [postFeedback.fulfilled]: (state, action) => {
            return {
                ...state,
                status: 'succeeded',
                statusObj: { ...state.statusObj, postFeedback: 'succeeded' }
            }
        },
        [postFeedback.rejected]: (state, action) => {
            return {
                ...state,
                status: 'failed',
                statusObj: { ...state.statusObj, postFeedback: 'failed' },
                error: action.error.message
            }
        }
    }
});

export const { reset } = feedbackSlice.actions;
export const selectFeedback = state => state.feedback.feedback;
export const selectFeedbackStatus = state => state.feedback.status;
export default feedbackSlice.reducer;
